import React, { Component, Fragment } from 'react';
import {withRouter, Link} from "react-router-dom";
import { inject, observer } from 'mobx-react';
import LoadingSpinner from '../loadingSpinner/';
import { numberFormat } from '../../common';

@withRouter
@inject('totoStore', 'dictStore')
@observer
export default class Cardsall extends Component{

  componentDidMount() {
    this.props.totoStore.Cardsall.init(this.props.match.params);
  }

  render() {
    const {isLoading, result, Cardsall} = this.props.totoStore;
    const {getLang} = this.props.dictStore;
    return(
      !isLoading ? 
        <div className="toto-index-loading">
          <LoadingSpinner />
        </div> :
      <Fragment>
        {Cardsall.data ? <TotoCards /> : <div className="toto-index-no">{getLang('INVALID_RESULT_ID')}</div>}
      </Fragment>
    )
  }
}

@inject('totoStore', 'dictStore')
@observer
class TotoCards extends Component { 

  selectCurrency = (e) => {
    this.props.totoStore.selectCurrency(e.target.value)
  }

  render() {

    const {getLang} = this.props.dictStore;
    const {currency, currencyId, current} = this.props.totoStore;
    const {data, page} = this.props.totoStore.Cardsall;
    let number = 0;

    return(
      <div className="toto-cardsall">
        <div className="clearfix">
          <div className="fl_r">
            <label htmlFor="toto-currency">{getLang('SHOW_IN_CURRENCY')} </label>
            <select className="toto-index-currency" onChange={this.selectCurrency}>
              {Object.keys(data.currency).map(id => 
                <option key={id} value={data.currency[id].id} selected={data.currency[id].id == currencyId}>{data.currency[id].full_name}</option>
              )}
            </select>
          </div>
          <div>
            <Link to={`/toto/result/${data.id}`}>{getLang('DETAILED_RESULTS_OF_DRAW')}</Link>
          </div>
        </div>
        <div className="toto-cardsall-data">
          <div>{getLang("DRAW")} #R-{data.number}, {data.date.start} - {data.date.end}</div>
          <div className="toto-cardsall-row clearfix">
              <div className="toto-cardsall-row-label fl_l">{getLang('TOTAL_BETS')}</div>
              <div className="toto-cardsall-row-data">{data.cards_count}</div>
          </div>
          <div className="toto-cardsall-row clearfix">
              <div className="toto-cardsall-row-label fl_l">{getLang('TOTAL_OPTIONS')}</div>
              <div className="toto-cardsall-row-data">{data.bets_count}</div>
          </div>
          <div className="toto-cardsall-row clearfix">
              <div className="toto-cardsall-row-label fl_l">{getLang('POOL')}</div>
              <div className="toto-cardsall-row-data">{numberFormat(data.pool[currencyId], 2, ',', ' ')} {current.name}</div>
          </div>
        </div>
        <div className="toto-cardsall-games-table-cont">
            <table className="toto-table">
                <thead>
                    <tr>
                        <th rowSpan="2">№</th>
                        <th rowSpan="2">{getLang('DATE')}</th>
                        <th rowSpan="2" colSpan="2">{getLang('EVENT')}</th>
                        <th colSpan="3">{getLang('POOL_DISTRIBUTION')}</th>
                        <th rowSpan="2">{getLang('RESULT')}</th>
                    </tr>
                    <tr>
                        <th>1</th>
                        <th>X</th>
                        <th>2</th>
                    </tr>
                </thead>
                <tbody>
                  { Object.keys(data.sport).map(sid => {
                    const league = data.sport[sid].league;
                    return (
                      league.map(lid => 
                        <Fragment key={`tr_${lid}`}>
                            <tr>
                              <td className="toto-table-league-name" colSpan="8">{data.dict.sport[sid]}. {data.dict.league[lid]}</td>
                            </tr>
                            {data.league[lid].games.map((gid, idx) => {
                              ++number;
                              return(
                                <tr className="toto-index-game"  key={`td_${gid}`}>
                                  <td className="toto-table-id">{number}</td>
                                  <td className="toto-table-date">{data.games[gid].date}</td>
                                  <td className="toto-table-cmd">{data.dict.cmd[data.games[gid].c1_id]}</td>
                                  <td className="toto-table-cmd">{data.dict.cmd[data.games[gid].c2_id]}</td>
                                  <td className="toto-table-pool-d">{data.games[gid].percent_1}%</td>
                                  <td className="toto-table-pool-d">{data.games[gid].percent_X}%</td>
                                  <td className="toto-table-pool-d">{data.games[gid].percent_2}%</td>
                                  <td className="toto-table-score">{data.games[gid].score != '{{ NO }}' ? getLang(data.games[gid].score) : getLang('NO')}</td>
                                </tr>
                              )
                            })}
                        </Fragment>
                      )
                    )}
                  )}
                </tbody>
            </table>
        </div>
        <Pages />
      </div>
    )
  }
} 

@inject('totoStore', 'dictStore')
@observer
class Pages extends Component{

  selectPage = (v) => {
    this.props.totoStore.Cardsall.selectPage(v);
  }

  render() {

    const {getLang} = this.props.dictStore;
    const {currency, currencyId} = this.props.totoStore;
    const {data, pages, page} = this.props.totoStore.Cardsall;

    return(
      <Fragment>
        <div className="toto-cardsall-page-list-cont clearfix">
          <nav>
            <ul className="toto-cardsall-page-list clearfix">
              {pages.map(el =>
                <li className="fl_l" key={el}>
                  <a className={`toto-cardsall-page-a${el == page ? ' toto-cardsall-page-a-selected' : ''}`} onClick={() => this.selectPage(el)}>{el}</a>
                </li>
              )}
            </ul>
          </nav>
        </div>
        <Table />
      </Fragment>
    )
  }
}

@inject('totoStore', 'dictStore')
@observer
class Table extends Component{
  render(){

    const {getLang} = this.props.dictStore;
    const {current, currencyId} = this.props.totoStore;
    const {data, pages, page, isLoading, pageData} = this.props.totoStore.Cardsall;
    const head = [];
    for (let i = 1; i <= 15; i++){
      head.push(<th>{i}</th>)
    }

    if (!pageData) return false;
    
    return(
      <div className="toto-cardsall-bet-table-cont">
        <table className="toto-table toto-cardsall-bet-table">
          <thead>
            <tr>
              <th>{getLang('CARD')}</th>
              <th>{getLang('AMOUNT')}</th>
              {head} 
            </tr>
          </thead>
            <tbody>
              {Object.keys(pageData.cards).map(id => {
                const item = pageData.cards[id];
                return (<tr>
                  <td className="toto-cardsall-bet-table-number"><Link to={`/toto/bet/${item.id}`}>{item.code}</Link></td>
                  <td className="toto-cardsall-bet-table-amount">{numberFormat(item.amount[currencyId], 2, ',', ' ')} {current.name}</td>
                  {item.option.map(x =>
                    <td className="t-c-b-t-o">{x}</td>
                  )}
                </tr>)
              })}
            </tbody> 
        </table>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/toto/cardsall.jsx